module.exports = __webpack_public_path__ + "static/img/21b.7b1ad90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/21b.png
// module id = ldQM
// module chunks = 1